export const CLOSE = 1;
export const OPEN = 0;
export const RESOLVED = 'RESOLVED';
export const REOPENED = 'REOPENED';
export const COMMENT = 'COMMENT';
export const STATUS = 'STATUS';
